export default "__VITE_ASSET__CaYEo38V__"